import { render, staticRenderFns } from "./playerCarrierDetails.vue?vue&type=template&id=d9be57aa&"
import script from "./playerCarrierDetails.vue?vue&type=script&lang=js&"
export * from "./playerCarrierDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports